import React from 'react';
import DocsViewer from '../components/DocsViewer';

const FrontendDocs = () => {
  return (
    <DocsViewer
      docsType="frontend"
      title="Promang Frontend Documentation"
    />
  );
};

export default FrontendDocs;

